// Type guards
export const isLineChartType = (props) => {
    return props.type === 'lineChart';
};
export const isBarChartType = (props) => {
    return props.type === 'barChart';
};
export const isStatsType = (props) => {
    return props.type === 'stats';
};
